// core
import React from "react";

// components
import LModal from "../../../../common/components/Modals/LModal/LModal";
import ModalHeader from "../../../../common/components/Modals/ModalHeader/ModalHeader";

// providers
import QuoteBreakdownSummary from "../../../../common/components/QuoteBreakdown/QuoteBreakdownSummary/QuoteBreakdownSummary";
import { IQuoteCardResult } from "../../../interfaces/results/IQuoteCardResult";
import { IClient } from "../../../../common/interfaces/IClient";
import { QuoteSettingContainerType } from "../../../../common/interfaces/settings/QuoteSettingContainerType";

interface IViewBreakdownModal {
    card: IQuoteCardResult;
    settings: QuoteSettingContainerType[];
    clients: IClient[];
    isOpen: boolean;
    onClose: () => void;
}

const calculateDiscount = (card: IQuoteCardResult): number => {
    return card.result.benefits
        .map((s) => s.discounts.reduce((base, add) => base + add.value, 0))
        .reduce((base, newVal) => base + newVal, 0);
};

const ViewBreakdownModal: React.FC<IViewBreakdownModal> = (props) => {
    const { isOpen, card, settings, clients, onClose } = props;

    const { providerId, policyFee, totalPremium } = card.result;

    return (
        <LModal
            Header={() => (
                <ModalHeader onClose={onClose} title="Price and cover details" />
            )}
            calcHeightMode="auto"
            width="wide"
            isOpen={isOpen}
            onClose={onClose}
            removePadding>
            {() => (
                <QuoteBreakdownSummary
                    providerId={providerId}
                    className={"padding-2xl"}
                    totalPremium={totalPremium}
                    totalCashback={card.totalCashback}
                    totalDiscount={calculateDiscount(card)}
                    clients={clients}
                    settings={settings}
                    benefits={card.result.benefits}
                    isCard={false}
                />
            )}
        </LModal>
    );
};

export default ViewBreakdownModal;
